import styled from "styled-components";
import Modal from "react-modal";
import { PurchaseDetailsMobile } from "./PurchaseDetails";
import { Close } from "../../assets/icons";

const ViewTicketModal = ({ closeModal, modalData, isModalOpen, onOpenCancelModal }) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Modal confirmation"
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          width: "25rem",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 999,
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <CloseImage src={Close} onClick={closeModal} />
        <PurchaseDetailsMobile data={modalData} isModal={true} onOpenCancelModal={onOpenCancelModal}/>
      </div>
    </Modal>
  );
};

export default ViewTicketModal;

const CloseImage = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  align-self: flex-end;
`;
